export default class UsuarioPessoaFisica{

    constructor(
        bn_tipo_de_pessoa = false,
        nm = null,
        nm_apelido = null,
        nm_senha = null,
        nm_rgouie = null,
        nm_cpfoucnpj = null,
        verifica_senha = null,
        nm_email = null,
        nm_email_confirmacao = null,
        nm_orgaoemissor = null,
        dt_nascimento = null,
        nm_celular = null,
        nm_telefone = null,
        bn_sexo = null,
        nm_nacionalidade = null,
        nm_cidadenascimento= null,
        nm_estadonascimento = null,
        nm_profissao = null,
        nm_pai = null,
        nm_mae = null,
        statusestadocivil_id = null,
        nm_conjuge = null,
        nm_rgconjuge = null,
        nm_cpfconjuge = null,
        nm_profissaoconjuge = null,
        nm_nacionalidadeconjuge = null,
        nm_orgaoemissorconjuge = null,
        statustipocasamento_id = null,
        dt_casamento = null,
        bn_aceite_condicao_de_venda = null,
        bn_politica_privacidade = null,
        codigo = null,
        etapa = null,
    ){
        this.bn_tipo_de_pessoa = bn_tipo_de_pessoa
        this.nm_apelido = nm_apelido
        this.nm = nm
        this.nm_senha = nm_senha
        this.verifica_senha = verifica_senha
        this.nm_rgouie = nm_rgouie
        this.nm_cpfoucnpj = nm_cpfoucnpj
        this.nm_email = nm_email
        this.nm_email_confirmacao = nm_email_confirmacao
        this.nm_orgaoemissor = nm_orgaoemissor
        this.dt_nascimento = dt_nascimento
        this.nm_cidadenascimento = nm_cidadenascimento
        this.nm_estadonascimento = nm_estadonascimento
        this.nm_celular = nm_celular
        this.nm_telefone = nm_telefone
        this.nm_profissao = nm_profissao
        this.nm_pai = nm_pai
        this.nm_mae = nm_mae
        this.statusestadocivil_id = statusestadocivil_id
        this.nm_conjuge = nm_conjuge
        this.nm_rgconjuge = nm_rgconjuge
        this.nm_orgaoemissorconjuge = nm_orgaoemissorconjuge
        this.nm_cpfconjuge = nm_cpfconjuge
        this.bn_sexo = bn_sexo
        this.nm_nacionalidade = nm_nacionalidade
        this.nm_profissaoconjuge = nm_profissaoconjuge
        this.nm_nacionalidadeconjuge = nm_nacionalidadeconjuge
        this.statustipocasamento_id = statustipocasamento_id
        this.dt_casamento = dt_casamento
        this.bn_aceite_condicao_de_venda = bn_aceite_condicao_de_venda
        this.bn_politica_privacidade = bn_politica_privacidade
        this.codigo = codigo
        this.etapa = etapa
    }
}
